import { Box, Typography, Container, Link } from "@mui/material";

export const ServiceUpdateNotice: React.FC = () => (
  <Container
    maxWidth="lg"
    sx={{
      py: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 5,
      }}
    >
      <Typography component="h1" variant="h5">
        {
          "【重要】「R.E.ASSIST」利用規約制定および「R.E.DATA Plus」料金改定のお知らせ"
        }
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        以下の通り利用規約の制定および料金改定を実施いたします
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        {"2026年2月1日より：「リアシスト（R.E.ASSIST）」利用規約の制定・施行"}
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        {
          "2026年3月1日より：「リデータプラス（R.E.DATA Plus）」登記解析機能の有料化"
        }
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        sx={{ marginTop: 2 }}
      >
        誠にお手数ですが、詳細は
        <Link
          href="https://www.trustart.co.jp/news/news260127/"
          target="_blank"
          rel="noopener"
        >
          こちら
        </Link>
        をご参照いただけますようお願い申し上げます。
      </Typography>
    </Box>
  </Container>
);
